import { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { getPatientImage } from 'api/routes';

function imageSource(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    const base64 = value.trim();
    if (/^data:image\/(jpeg|png|webp);base64,/i.test(base64)) return base64;
    const type = base64.startsWith('iVBOR') ? 'png' : base64.startsWith('UklGR') ? 'webp' : 'jpeg';
    return `data:image/${type};base64,${base64}`;
}

function PrescriptionImage({ file, index }) {
    const [loading, setLoading] = useState(true);
    const [failed, setFailed] = useState(false);
    const src = imageSource(file.fileSrc);
    return <Box sx={{ mb: 2, textAlign: 'center' }}>
        {loading && !failed && src && <CircularProgress size={28} aria-label="بارگذاری تصویر" />}
        {(failed || !src) && <Alert severity="error">تصویر نسخه قابل نمایش نیست.</Alert>}
        {src && <Box component="img" src={src} alt={`تصویر نسخه ${index + 1}`}
            onLoad={() => setLoading(false)} onError={() => { setLoading(false); setFailed(true); }}
            sx={{ display: failed ? 'none' : 'block', maxWidth: '100%', height: 'auto', mx: 'auto', objectFit: 'contain' }} />}
    </Box>;
}

export default function PrescriptionModal({ patient, onClose }) {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(patient?.patientId != null);
    const [error, setError] = useState('');
    const [retry, setRetry] = useState(0);
    const patientId = patient?.patientId;
    const preloadedFiles = patient?.prescriptionFiles;
    useEffect(() => {
        let active = true;
        setFiles([]);
        setError('');
        if (patientId == null) { setLoading(false); return undefined; }
        if (Array.isArray(preloadedFiles)) {
            setFiles(preloadedFiles);
            setLoading(false);
            return undefined;
        }
        setLoading(true);
        getPatientImage(patientId, (isOk, data) => {
            if (!active) return;
            setLoading(false);
            if (!isOk) {
                setError(data?.message || 'دریافت تصویر نسخه ناموفق بود.');
                return;
            }
            setFiles(Array.isArray(data) ? data : []);
        });
        return () => { active = false; };
    }, [patientId, retry, preloadedFiles]);

    return <Dialog open={patientId != null} onClose={onClose} fullWidth maxWidth="md" aria-labelledby="prescription-title">
        <DialogTitle id="prescription-title">تصویر نسخه — {patient?.firstName} {patient?.lastName} (کد پیگیری: {patientId})</DialogTitle>
        <DialogContent dividers sx={{ minHeight: 180 }}>
            {loading ? <Box sx={{ py: 4, textAlign: 'center' }}><CircularProgress size={36} /><Box sx={{ mt: 2 }}>در حال دریافت تصویر نسخه...</Box></Box>
                : error ? <Alert severity="error" action={<Button onClick={() => setRetry(value => value + 1)}>تلاش مجدد</Button>}>{error}</Alert>
                    : files.length ? files.map((file, index) => <PrescriptionImage key={`${patientId}-${retry}-${file.fileId ?? index}`} file={file} index={index} />)
                        : <Alert severity="info">برای این بیمار تصویر نسخه‌ای بارگذاری نشده است.</Alert>}
        </DialogContent>
        <DialogActions><Button onClick={onClose}>بستن</Button></DialogActions>
    </Dialog>;
}
